<template>
  <b-card-text>
      <div class="d-flex justify-content-between">
        <h5>Шапка договора</h5>
        <b-button
          @click="predprosmotr = !predprosmotr"
        >
          Предпросмотр
        </b-button>
      </div>
      <div v-if="predprosmotr" class="predprosmotr-card">
        <p class="text-center font-weight-bold">ДОГОВОР<br>НА ТРАНСПОРТНО - ЭКСПЕДИЦИОННОЕ ОБСЛУЖИВАНИЕ № {{ docHistory['typ_dog_teo_exp'].number_of_dogovor }}Э</p>
        
        <div class="d-flex justify-content-between mb-3">
          <div>г. Москва</div>
          <div class="text-right">«{{ docHistory['typ_dog_teo_exp'].day_of_dogovor || '____' }}» {{ docHistory['typ_dog_teo_exp'].month_of_dogovor || '_______________' }} {{ docHistory['typ_dog_teo_exp'].year_of_dogovor || '2025' }} г.</div>
        </div>
        
        <p class="text-justify">&emsp;&emsp;&emsp;&emsp;{{ docHistory['typ_dog_teo_exp'].full_pravovaya_form }} {{ docHistory['typ_dog_teo_exp'].full_pravovaya_form === 'Индивидуальный предприниматель' ? docHistory['typ_dog_teo_exp'].full_org_name_not_caps : ('«' + docHistory['typ_dog_teo_exp'].full_org_name + '»') }}, {{ docHistory['typ_dog_teo_exp'].full_pravovaya_form === 'Индивидуальный предприниматель' ? 'именуемый' : 'именуемое' }} в дальнейшем «Заказчик», в лице {{ docHistory['typ_dog_teo_exp'].in_face_of_org }} {{ docHistory['typ_dog_teo_exp'].fio_of_face_of_org }}, действующего на основании {{ docHistory['typ_dog_teo_exp'].is_ustav }}{{ docHistory['typ_dog_teo_exp'].is_ustav === 'ОГРНИП' ? (' ' + docHistory['typ_dog_teo_exp'].ogrn_of_org) : '' }}, с одной стороны и Общество с ограниченной ответственностью «ТАНАИС Брокер», именуемое в дальнейшем «Экспедитор», в лице генерального директора Бородиной Елены Эдуардовны, действующей на основании Устава, с другой стороны, договорились о нижеследующем:</p>
      </div>

      <b-row class="my-2">
        <b-col cols="5">
          <label class="small-label">Номер договора:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].number_of_dogovor"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <label class="small-label">День договора:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].day_of_dogovor"
            size="sm"
            type="number"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <label class="small-label">Месяц договора:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].month_of_dogovor"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <label class="small-label">Год договора:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].year_of_dogovor"
            size="sm"
            type="number"
            trim
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col cols="5">
          <label class="small-label">Полная правовая форма:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].full_pravovaya_form"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="7">
          <label class="small-label">Наименование организации без признаков:</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].full_org_name"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col cols="5">
          <label class="small-label">В лице (генерального директора и т.д.):</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].in_face_of_org"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="7">
          <label class="small-label">ФИО лица (родительный падеж, полностью):</label>
          <b-form-input
            :value="docHistory['typ_dog_teo_exp'].fio_of_face_of_org"
            @input="docHistory['typ_dog_teo_exp'].fio_of_face_of_org = toUpperCase($event)"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-2">
        <b-col>
          <label class="small-label">На основании (Устава, Доверенности, др.):</label>
          <b-form-input
            v-model="docHistory['typ_dog_teo_exp'].is_ustav"
            size="sm"
            trim
          ></b-form-input>
        </b-col>
      </b-row>
    </b-card-text>
</template>

<script>
export default {
  data() {
    return {
      predprosmotr: false,
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toUpperCase(string) {
      return string.toLowerCase().replace(/( |^)[а-яёa-z]/g, (letter) => letter.toUpperCase())
    },
  },
}
</script>

<style lang="scss" scoped>
  .small-label {
    font-size: 12px;
  }

  .predprosmotr-card {
    padding: 15px;
    margin: 20px 0;
    background: #cccccc59;
  }
</style>